import { MacroParts } from '../types/MacroParts';

export const createMacro = (parts: MacroParts): string => {
  const { token, operator, value } = parts;

  const colons = token[token.length - 1] === ':' ? '' : ':';
  const quotes = (value || '').includes(' ') ? '"' : '';

  if (value) {
    if (operator) {
      return `${token}${colons}${operator}(${value})`;
    }

    return `${token}${colons}${quotes}${value}${quotes}`;
  }

  if (operator) {
    return `${token}${colons}${operator}`;
  }

  return `${token}${colons}`;
};
